<template>
    <div class="tsa-mobile-header">
        <div id="tsa-mobile-navigation"></div>
    </div>
</template>

<script>
import 'tsa-components-umd/dist/tsa-components-umd.min.css'
const TsaComponentsUmd = require('tsa-components-umd')
export default {
    data () {
        return {

        }
    },
    components: {},
    computed: {},
    created() {},
    mounted() {
        this.$nextTick(() => {
            TsaComponentsUmd.navigation({
                foldUnit:'px',
                env: process.env.NODE_ENV,
                currentPath: 'https://sharing.tsa.cn',
                logoHref: process.env.VUE_APP_TSAPLUS,
            })
        })
    },
    methods: {

    },
}

</script>
<style scoped lang='less'>
.tsa-mobile-header{
    /deep/#tsa-mobile-navigation{
        height: 156px;
        padding-top: 0;
        .tsa-mobile-navigation-container{
            .foldOpening{
                height: auto !important;
            }
            .tsa-mobile-timeStamp{
                font-size: 24px;
                height: 52px;
            }
            .tsa-mobile-nav{
                height: 104px;
                padding: 28px 40px 12px;
                // &::after {
                //     left: 40px;
                //     right: 40px;
                //     height: 40px;
                // }
                .tsa-iconfont-umd{
                    font-size:48px;
                    height: 48px;
                }
                a{
                    img{
                        height: 64px !important;
                    }
                }
            }
            .tsa-mobile-slide{
                top: 52px;
                width: 600px;
                padding:22px 0;
                transform: translateX(-600px) !important;
                .slide-title{
                    height: 74px;
                    padding-right: 40px;
                    .slide-title-left{
                        height: 74px;
                        h2 {
                            font-size: 36px;
                            line-height: 74px;
                            padding: 0 20px;
                            min-width: 240px;
                        }
                        img {
                            width: 58px;
                            height: 74px;
                        }
                    }
                    .tsa-iconfont-umd{
                        font-size: 40px;
                    }
                }
                .slide-content{
                    padding: 4px 40px 0;
                    .first-item{
                        height: 102px;
                        border-width: 2px;
                        a{
                            img{
                                width: 24px;
                                height: 24px;
                                margin-right: 8px;
                            }
                            h3{
                                font-size: 36px;
                                line-height: 40px;
                            }
                        }
                    }
                    .first-part {
                        .first-part-title {
                            height: 102px;
                            img {
                                width: 24px;
                                height: 24px;
                                margin-right: 8px;
                            }
                            h3 {
                                font-size: 36px;
                                line-height: 40px;
                            }
                            .tsa-icon-arrow-right {
                                font-size: 48px;
                            }
                        }
                        .first-part-content {
                            border-bottom: 2px solid #DCDBDB;
                            .first-part-content-item {
                                height: 76px;
                                &:first-child {
                                    margin-top: 14px;
                                }
                                &:last-child {
                                    margin-bottom:14px;
                                }
                                a {
                                    &.noIcon {
                                        padding-left: 28px;
                                    }
                                    .tsa-iconfont-umd  {
                                        font-size: 48px;
                                        margin-right: 10px;
                                    }
                                    h3 {
                                        font-size: 32px;
                                        line-height: 38px;
                                    }
                                }
                            }
                            .secodn-part {
                                padding-bottom: 28px;
                                border-bottom: 2px solid #DCDBDB;
                                .secodn-part-title {
                                    .tsa-iconfont-umd  {
                                        font-size: 48px;
                                        &:first-child {
                                            margin-right: 10px;
                                        }
                                    }
                                    h4 {
                                        font-size: 32px;
                                        line-height: 38px;
                                    }
                                }
                                .secodn-part-content {
                                    padding-left: 60px;
                                    a {
                                        font-size: 32px;
                                        line-height: 38px;
                                        margin-bottom: 24px;
                                        &:first-child {
                                            padding-top: 28px;
                                        }                                    
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .opening{
                transform: translateX(0px) !important;
            }
        }
    }
}
</style>